import React from 'react';
import { Link } from 'react-router-dom';
const services = [{
  label: 'Mobile Detailing',
  to: '/services/mobile-detailing'
}, {
  label: 'Interior Detailing',
  to: '/services/interior-detailing'
}, {
  label: 'Exterior Detailing',
  to: '/services/exterior-detailing'
}, {
  label: 'Full Car Detail',
  to: '/services/full-car-detail'
}, {
  label: 'Engine Bay Detailing',
  to: '/services/engine-bay-detailing'
}, {
  label: 'Headlight Restoration',
  to: '/services/headlight-restoration'
}, {
  label: 'Ceramic Coating',
  to: '/services/ceramic-coating'
}];
const citiesList = [{
  label: 'Camarillo',
  to: '/ventura-county/camarillo'
}, {
  label: 'Oxnard',
  to: '/ventura-county/oxnard'
}, {
  label: 'Ventura',
  to: '/ventura-county/ventura'
}, {
  label: 'Thousand Oaks',
  to: '/ventura-county/thousand-oaks'
}, {
  label: 'Simi Valley',
  to: '/ventura-county/simi-valley'
}, {
  label: 'Moorpark',
  to: '/ventura-county/moorpark'
}, {
  label: 'Newbury Park',
  to: '/ventura-county/newbury-park'
}, {
  label: 'Westlake Village',
  to: '/ventura-county/westlake-village'
}];
export function SeoContent() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" aria-labelledby="seo-content-heading" data-id="element-319" data-mp="3i2w2sx7igxqq">
      <div className="max-w-4xl mx-auto" data-id="element-320" data-mp="3n04jsugxavqe">
        <div className="prose prose-invert prose-lg max-w-none prose-headings:font-black prose-headings:uppercase prose-headings:tracking-tight prose-h2:text-3xl md:prose-h2:text-4xl prose-h2:mb-5 prose-h2:mt-12 first:prose-h2:mt-0 prose-h3:text-xl prose-h3:text-yellow-400 prose-p:text-gray-300 prose-p:leading-relaxed prose-li:text-gray-300 prose-strong:text-white prose-a:text-red-500 hover:prose-a:underline" data-id="element-321" data-mp="3rsperzbkfevi">
          <h2 id="seo-content-heading" data-id="element-322" data-mp="elvym7gqd789">
            Mobile Detailing in Ventura County, Done Right
          </h2>
          <p data-id="element-323" data-mp="2bf7kucp6phtd">
            <strong data-id="element-324" data-mp="2bfqt11p18ru7">Mike's Pro Detail</strong> is a premium{' '}
            <strong data-id="element-325" data-mp="2gc7ibz7yxc8v">mobile car detailing</strong> company proudly serving{' '}
            <strong data-id="element-326" data-mp="3jnmwhduy8qli">Ventura County, California</strong>. We bring a fully
            equipped, professional detail shop directly to your driveway, so you
            get a flawless, showroom-quality finish without ever leaving home.
            From{' '}
            <Link to="/ventura-county/camarillo" data-id="element-327" data-mp="3spw7s5y1knzy">
              mobile detailing in Camarillo
            </Link>{' '}
            and <Link to="/ventura-county/oxnard" data-id="element-328" data-mp="3nrupvoccquq2">car detailing in Oxnard</Link>{' '}
            to{' '}
            <Link to="/ventura-county/ventura" data-id="element-329" data-mp="6f1s8hx6zss5">auto detailing in Ventura</Link>,
            our mobile team comes to you fully self-contained with our own
            water, power, and premium eco-friendly products. There is no
            drop-off, no waiting room, and no compromise on quality.
          </p>
          <p data-id="element-330" data-mp="p7vxul8xe8jp">
            Whether you searched for <em data-id="element-331" data-mp="p8xinhfqu9em">"car detailing near me"</em>,{' '}
            <em data-id="element-332" data-mp="p5jjei2dmgbe">"mobile car detailing Ventura County"</em>, or a specific
            service in your city, you have found the most trusted name in local
            auto detailing. We treat every vehicle as if it were our own,
            combining meticulous hand work with professional-grade equipment to
            deliver results that protect your investment and turn heads.
          </p>

          <h2 data-id="element-333" data-mp="tyriuy5wei5o">Why Choose Mobile Detailing?</h2>
          <p data-id="element-334" data-mp="yugmpdoyal7s">
            Traditional car washes are fast but harsh — automated brushes and
            recycled water can leave swirl marks and scratches in your clear
            coat. Professional mobile detailing is the opposite: a careful,
            hand-crafted process performed right where you live or work.
            Choosing{' '}
            <Link to="/services/mobile-detailing" data-id="element-335" data-mp="b3t3hw9l495x">
              mobile detailing in Ventura County
            </Link>{' '}
            gives you several major advantages:
          </p>
          <ul data-id="element-336" data-mp="260vld6703sk">
            <li data-id="element-337" data-mp="27lf87qyy2bn">
              <strong data-id="element-338" data-mp="66t3a1zf20mq">Convenience:</strong> We come to your home, office, or
              apartment. You reclaim hours of your day instead of sitting at a
              shop.
            </li>
            <li data-id="element-339" data-mp="3q9xit0hz051h">
              <strong data-id="element-340" data-mp="3q9dzbfco98lc">Quality:</strong> Hand washing, clay bar decontamination,
              and careful interior work that automated washes simply cannot
              match.
            </li>
            <li data-id="element-341" data-mp="3gkdxlo6sbz3g">
              <strong data-id="element-342" data-mp="3gkw4rfuzjxq5">Self-contained service:</strong> We bring our own water
              and power, so no hookups are required on your end.
            </li>
            <li data-id="element-343" data-mp="3cg67pnolcd3n">
              <strong data-id="element-344" data-mp="37jpjyulb00r3">Protection:</strong> Premium waxes, sealants, and ceramic
              coatings that shield your paint from the Southern California sun
              and coastal salt air.
            </li>
          </ul>

          <h2 data-id="element-345" data-mp="2xm1qs93cj1b1">Our Professional Detailing Services</h2>
          <p data-id="element-346" data-mp="2xnmizs26u85q">
            We offer a complete range of mobile detailing services for cars,
            trucks, and SUVs across Ventura County. Each service is performed
            on-site and tailored to your vehicle's specific needs.
          </p>

          <h3 data-id="element-347" data-mp="149un164c46w1">Interior Detailing</h3>
          <p data-id="element-348" data-mp="148taex7o7cc7">
            Our{' '}
            <Link to="/services/interior-detailing" data-id="element-349" data-mp="18c91le0z0khi">interior detailing</Link>{' '}
            service deep cleans, shampoos, steam sanitizes, and conditions every
            surface inside your cabin. We remove embedded dirt, pet hair,
            stains, and odors, restoring a fresh, like-new feel while improving
            the air quality you breathe on every drive.
          </p>

          <h3 data-id="element-350" data-mp="pdn56cgefhjx">Exterior Detailing</h3>
          <p data-id="element-351" data-mp="peod4824bnxf">
            Our{' '}
            <Link to="/services/exterior-detailing" data-id="element-352" data-mp="pfpq4i2p2khs">exterior detailing</Link>{' '}
            service includes a safe hand wash, clay bar treatment, wheel and
            tire cleaning, and a durable wax or sealant. This safely removes
            bonded contaminants, restores deep gloss, and protects your paint
            from UV damage and oxidation.
          </p>

          <h3 data-id="element-353" data-mp="2apohjpi6089o">Full Car Detail</h3>
          <p data-id="element-354" data-mp="2at2kozynkli6">
            Our most popular package, the{' '}
            <Link to="/services/full-car-detail" data-id="element-355" data-mp="1l1j2su7uovwy">full car detail</Link>,
            combines our complete interior and exterior services for a true
            bumper-to-bumper transformation. It is the most cost-effective way
            to completely reset your vehicle's condition inside and out.
          </p>

          <h3 data-id="element-356" data-mp="1q2gi8z1h7bur">Engine Bay Detailing</h3>
          <p data-id="element-357" data-mp="12cchczfo9q7g">
            Our{' '}
            <Link to="/services/engine-bay-detailing" data-id="element-358" data-mp="12de5a4hse76l">
              engine bay detailing
            </Link>{' '}
            safely degreases and cleans your engine compartment, making it
            easier to spot leaks, helping prevent heat-trapping grime, and
            dramatically improving your vehicle's presentation and resale value.
          </p>

          <h3 data-id="element-359" data-mp="jlv3g0zi0z65">Headlight Restoration</h3>
          <p data-id="element-360" data-mp="jkteqtpk8e5y">
            Cloudy, yellowed headlights are both an eyesore and a safety hazard.
            Our{' '}
            <Link to="/services/headlight-restoration" data-id="element-361" data-mp="em8ptqfrdgwt">
              headlight restoration
            </Link>{' '}
            service permanently removes oxidation and restores crystal-clear
            lenses, improving your nighttime visibility and your car's
            appearance.
          </p>

          <h3 data-id="element-362" data-mp="2gdio4wo9fdwa">Ceramic Coating</h3>
          <p data-id="element-363" data-mp="2ga37vqiunyta">
            For enthusiasts and luxury vehicle owners, our{' '}
            <Link to="/services/ceramic-coating" data-id="element-364" data-mp="2lbagtswqb41j">ceramic coating</Link> locks in
            a deep, glossy finish with years of durable, hydrophobic protection
            against UV rays, dirt, and contaminants.
          </p>

          <h2 data-id="element-365" data-mp="2zzx36ekrww29">Serving All of Ventura County</h2>
          <p data-id="element-366" data-mp="2zz57l3r6eybz">
            As a mobile operation, we bring our detailing service to every
            community in Ventura County. Wherever you are, we come to you with a
            complete, professional detail. Explore our dedicated city pages for
            local information and pricing:
          </p>
          <div className="not-prose grid grid-cols-2 sm:grid-cols-4 gap-3 my-8" data-id="element-367" data-mp="1snwn03obuoln">
            {citiesList.map(c => <Link key={c.to} to={c.to} className="block text-center px-3 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold text-sm hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-368" data-mp="2kbhhpa82tban">
                {c.label}
              </Link>)}
          </div>
          <p data-id="element-369" data-mp="26bgjy3n3yjze">
            We provide{' '}
            <Link to="/ventura-county/camarillo" data-id="element-370" data-mp="26chxcerljika">
              mobile detailing in Camarillo
            </Link>
            , <Link to="/ventura-county/oxnard" data-id="element-371" data-mp="2yz2md8klniko">car detailing in Oxnard</Link>,{' '}
            <Link to="/ventura-county/ventura" data-id="element-372" data-mp="2z16pvpel6fkf">auto detailing in Ventura</Link>,{' '}
            <Link to="/ventura-county/thousand-oaks" data-id="element-373" data-mp="2u5zqgtscnx1b">
              detailing in Thousand Oaks
            </Link>
            , <Link to="/ventura-county/simi-valley" data-id="element-374" data-mp="2p76l5on7vcc8">Simi Valley</Link>,{' '}
            <Link to="/ventura-county/moorpark" data-id="element-375" data-mp="3mppw7ze2si9v">Moorpark</Link>,{' '}
            <Link to="/ventura-county/newbury-park" data-id="element-376" data-mp="3hwnceiz3on6v">Newbury Park</Link>, and{' '}
            <Link to="/ventura-county/westlake-village" data-id="element-377" data-mp="3p9crzi2ucypl">Westlake Village</Link>.
            From the coast to the inland valleys, our mobile detailing service
            is never far away.
          </p>

          <h2 data-id="element-378" data-mp="31d8kiudbcr1">Why Ventura County Trusts Mike's Pro Detail</h2>
          <p data-id="element-379" data-mp="33zfqhdcjq8q">
            With a 5-star reputation built across Ventura County, Mike's Pro
            Detail has earned the loyalty of drivers who demand the very best
            for their vehicles. Our success comes down to a simple philosophy:
            uncompromising quality, genuine convenience, and treating every
            customer's car with the same care we would give our own. We use only
            premium, eco-friendly products and professional-grade equipment, and
            we never rush a job — because a truly great detail takes time and
            attention.
          </p>
          <p data-id="element-380" data-mp="uqy74ppcwr8y">
            Our experienced technicians understand the unique challenges of
            Southern California vehicles: relentless UV exposure that fades
            paint and cracks interiors, coastal salt air that accelerates
            corrosion, and fine inland dust that works its way into every
            surface. Every service we provide is designed to combat these
            conditions and keep your vehicle protected, beautiful, and holding
            its value for years to come.
          </p>

          <h2 data-id="element-381" data-mp="2lh789z7dhss2">How Our Mobile Detailing Process Works</h2>
          <p data-id="element-382" data-mp="2lgp8isli4wfe">
            Booking is simple. Call or text Mike directly, describe your vehicle
            and the service you need, and we will provide a clear quote and find
            a time that works for you — including weekends. On the day of your
            appointment, our fully equipped mobile unit arrives at your home or
            office with everything required to complete the detail on-site. You
            stay productive or relax while we transform your vehicle, and you
            inspect the results before we leave. It is professional auto
            detailing made effortless.
          </p>

          <h2 data-id="element-383" data-mp="3jcax7h6i85k0">Book Your Mobile Detail Today</h2>
          <p data-id="element-384" data-mp="3eiovgk1vpm2z">
            Ready to experience the convenience and quality of mobile detailing
            in Ventura County? Whether you need a quick maintenance wash, a
            complete full detail, or specialty services like ceramic coating and
            headlight restoration, Mike's Pro Detail is ready to bring the shop
            to you. Call or text <a href="tel:8183819905" data-id="element-385" data-mp="22cyf7b3uqz1">(818) 381-9905</a>{' '}
            today, or <a href="/#contact-form" data-id="element-386" data-mp="234hjinimw8f">request a free quote online</a>,
            and discover why drivers throughout Camarillo, Oxnard, Ventura,
            Thousand Oaks, and all of Ventura County trust us with their
            vehicles.
          </p>
        </div>
      </div>
    </section>;
}